import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Chart } from "components/Chart";
import { panelPropTypes } from "components/Panels/panelPropTypes";
import moment from "moment";
import { commonPrecisionFormatter } from "core/utils/highcharts";

function extractDisplayVars(props) {
  const r = {};
  const { displayVariables } = props;
  if (displayVariables && displayVariables.length > 0) {
    if (displayVariables[0].yAxisMin) {
      r["yAxisMin"] = displayVariables[0].yAxisMin;
    }
    if (displayVariables[0].yAxisMax) {
      r["yAxisMax"] = displayVariables[0].yAxisMax;
    }
  }

  return {
    displayVars: r
  };
}

function tooltipFormatter() {
  const label = this.series.name;
  const dt = moment(this.x);
  const value = this.y?.toPrecision(4) ?? "NaN";
  return `${label}<br />${dt.format("DD MMM YYYY HH:mm")}: <b>${value}</b>`;
}

const defaultHighchartsOptions = props => ({
  title: {
    text: null
  },
  boost: { enabled: true },
  exporting: { enabled: false },
  credits: { enabled: false },
  xAxis: {
    title: {
      text: null
    },
    type: "datetime",
    minRange: 10 * 60 * 1000, // 10 minutes
    events: {
      afterSetExtremes: e => (props.afterSetExtremes ?? (() => {}))(e)
    }
  },
  yAxis: {
    visible: props.visibleY ?? true,
    title: {
      text: props.unit
    },
    labels: { formatter: commonPrecisionFormatter },
    min: props.displayVars?.yAxisMin ?? null,
    max: props.displayVars?.yAxisMax ?? null
  },
  chart: {
    type: "line",
    zoomType: "x",
    height: props.height
  },
  plotOptions: {
    series: {
      animation: { duration: 500 },
      marker: { enabled: false }
    }
  },
  series: props.data,
  legend: {
    enabled: props.legendEnabled
  },
  tooltip: {
    formatter: tooltipFormatter
  }
});

const SplineChart = React.memo(function SplineChart(props) {
  const [options, setOptions] = useState(
    defaultHighchartsOptions({
      ...props,
      ...extractDisplayVars(props),
      data: []
    })
  );
  const { width, height } = props;

  useEffect(() => {
    setOptions(
      defaultHighchartsOptions({
        ...props,
        ...extractDisplayVars(props),
        height: props.height
      })
    );
  }, [props]);

  return (
    <div style={{ width, height }}>
      <Chart chartOptions={options} />
    </div>
  );
});

SplineChart.propTypes = {
  data: PropTypes.array,
  legendEnabled: PropTypes.bool,
  unit: PropTypes.string,
  afterSetExtremes: PropTypes.func,
  ...panelPropTypes
};

export function StaticSplinePanel(props) {
  return <SplineChart {...props} />;
}

StaticSplinePanel.propTypes = SplineChart.propTypes;
